import React, { useState } from 'react';
import {
    SideNav, SideNavItems, SideNavLink, SideNavMenu,
    HeaderContainer, Header, SkipToContent, HeaderMenuButton, HeaderName, Button, SideNavMenuItem
} from 'carbon-components-react';
import { DotMark16 as Bullet, CaretRight16 } from '@carbon/icons-react';
import *  as DashboardConstants from '../Dashboards/DashboardConstants'

const BPMNSideNav = (props) => {
    const [expandSideNav, setExpandSideNav] = useState(false);

    const toggleSideNav = () => {
        setExpandSideNav(!expandSideNav)
    }
    const hideSideNav = () => {
        setExpandSideNav(false);
    }

    return (
        <HeaderContainer
            render={({ isSideNavExpanded, onClickSideNavExpand }) => (
                <>
                    <Header aria-label="">
                        <SkipToContent />
                        {expandSideNav && <HeaderName prefix={DashboardConstants.Bpmn}></HeaderName>}
                        <HeaderMenuButton
                            aria-label="Open menu"
                            isCollapsible
                            onClick={() => { onClickSideNavExpand(); toggleSideNav(); }}
                            isActive={expandSideNav}
                        />
                        <SideNav
                            aria-label="Side navigation"
                            isRail
                            expanded={expandSideNav}>
                            <SideNavItems>
                                <SideNavMenu renderIcon={Bullet} title={<span title={DashboardConstants.Reporting}>{DashboardConstants.Reporting}</span>}>
                                    <SideNavMenuItem className="shift-left-3" isActive={props.SummaryDropdown === "FinanceReporting" ? true : false}
                                        onClick={() => { props.handleSummaryDropdownValue('FinanceReporting'); hideSideNav(); }}>
                                        <Button kind='ghost' size='sm'>
                                            <span title={DashboardConstants.FinanceReporting}>{DashboardConstants.FinanceReporting}</span>
                                        </Button>
                                    </SideNavMenuItem>
                                </SideNavMenu>
                                <SideNavMenu renderIcon={Bullet} title={<span title={DashboardConstants.OrderManagement}>{DashboardConstants.OrderManagement}</span>}>
                                    <SideNavMenuItem className="shift-left-3" isActive={props.SummaryDropdown === "orderToCash" ? true : false}
                                        onClick={() => { props.handleSummaryDropdownValue('orderToCash'); hideSideNav(); }}>
                                        <Button kind='ghost' size='sm'>
                                            <span title={DashboardConstants.OrderToCash}>{DashboardConstants.OrderToCash}</span>
                                        </Button>
                                    </SideNavMenuItem>
                                    {/* <SideNavMenuItem className="shift-left-3" isActive={props.SummaryDropdown === "orderToCashV1" ? true : false}
                                        onClick={() => { props.handleSummaryDropdownValue('orderToCashV1'); hideSideNav(); }}>
                                        <Button kind='ghost' size='sm'>
                                            <span title={DashboardConstants.OrderToCashV1}>{DashboardConstants.OrderToCashV1}</span>
                                        </Button>
                                    </SideNavMenuItem> */}
                                </SideNavMenu>
                            </SideNavItems>
                        </SideNav>
                    </Header>
                </>
            )}
        />
    );
}

export default BPMNSideNav
